module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("6NBej"))).then(() => parcelRequire('k0bnv'));